import React from "react";

interface PageMainProps {
  children: React.ReactNode;
  className?: string;
}
export const PageMain = ({ children, className = "" }: PageMainProps): JSX.Element | null => {
  return <main className={`grow p-4 md:p-10 md:pt-4 ${className}`}>{children}</main>;
};
